export const mozSystemsData = [
    {
        month: 'Январь',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Февраль',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Март',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Апрель',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Май',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Июнь',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Июль',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Август',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Сентябрь',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Октябрь',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Ноябрь',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
    {
        month: 'Декабрь',
        description: [
            {
                number: 1,
                owner: 'FBI',
                name: 'Web'
            },
            {
                number: 2,
                owner: 'FBI',
                name: 'Desktop'
            },
            {
                number: 3,
                owner: 'FBI',
                name: 'Mobile'
            },
            {
                number: 4,
                owner: 'FBI',
                name: 'Data'
            },
            {
                number: 5,
                owner: 'FBI',
                name: 'PWA'
            },
        ]
    },
]